import { render, staticRenderFns } from "./patientContactList.vue?vue&type=template&id=361bb1fc&scoped=true"
import script from "./patientContactList.vue?vue&type=script&lang=js"
export * from "./patientContactList.vue?vue&type=script&lang=js"
import style0 from "./patientContactList.vue?vue&type=style&index=0&id=361bb1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361bb1fc",
  null
  
)

export default component.exports